<template>
  <v-app>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12">
          <v-breadcrumbs>
            <v-breadcrumbs-item>
              <router-link to="/">Home</router-link>
            </v-breadcrumbs-item>
            <span class="divider">></span>
            <v-breadcrumbs-item disabled>
                Parking Coupons
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-col>
      </v-row>

      <v-row no-gutters class="px-5">
        <v-col cols="12">
            <h1>Parking Coupons</h1>
            
            <v-row>
                <v-col cols="4">
                    <v-img src="@/assets/parking-coupon-1.jpeg" class="mb-4"></v-img>
                </v-col>
                <v-col cols="4">
                    <v-img src="@/assets/parking-coupon-2.jpeg" class="mb-4"></v-img>
                </v-col>
                <v-col cols="4">
                    <v-img src="@/assets/parking-coupon-3.jpeg" class="mb-4"></v-img>
                </v-col>
            </v-row>

            <div class="mb-12">
                <p>
                    Parking coupons can be purchased from all of the 15 parking coupons booths located at strategic location in the City of Miri. Please click Find BPS BOOTH for the one nearest to you.<br><br>
                    The common denominations, i.e. RM0.40, RM1.60 and RM5.00, parking coupons (exclusive of government tax) are available at all BPS coupon booths.<br><br>
                    Please take note that RM0.40 parking coupons can only be used for the 1st half hour of parking at blue zone and first 1 hour at green zone, the RM1.60 parking coupons can be used 1 hour at blue zone and 2 hour at green zone while the RM5.00 is a daily parking coupon (1 full day parking coupon)<br><br>
                    Decide on how long you are likely to stay on arrival at a parking space, scratch off completely the 5 relevant tabs (year, month, day, hour & minutes) and display the coupons prominently, visibly and neatly on the dashboard in front of you.<br><br>
                    For those who have over parked, BPS parking wardens will issue over parking compound (OPC) which they will have to pay within fourteen (14) working days after the date of the OPN issued at BPS coupon booths. Please always ensure and check your receipts when making payments at the parking booths.<br><br>
                    Please always tear of a piece of coupon from the coupon booklet for display at the dashboard and not the whole booklet as the direct heat from the sun will dry up the ink making them hard to scratch off later.
                </p>
            </div>

            <div class="mb-12">
                <p class="font-weight-medium">How coupon parking system works</p>
                <ol class="ps-6">
                    <li>Buy parking coupons in advance</li>
                    <li>Plan your parking period, if you need more than 1 coupon to cover the parking duration, the start time of the second coupon should be the expiry time of the first coupon.</li>
                    <li>Scratch off completely the six relevant tabs to indicate the year, month, day, commencing time of parking (hour and minute) and lastly parking either at blue or green zone</li>
                    <li>Display the coupons visibly and neatly on the front dashboard of your car. Do not leave any used coupons on the dashboard of your vehicle</li>
                </ol>
            </div>

            <v-row>
                <v-col cols="12">
                    <div class="mb-12">
                        <h3>Types of parking coupons available</h3>
                        <p class="font-weight-medium">Parking charges for cars</p>
                        
                        <v-card class="px-12 py-8 mb-6">
                            <v-table>
                                <thead>
                                    <tr>
                                        <th colspan="2">At Blue Zone (Blue Numbering)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>RM0.42 (inclusive of 6% GST)</td>
                                        <td>per 1/2 hourly</td>
                                    </tr>
                                    <tr>
                                        <td>RM1.70 (inclusive of 6% GST)</td>
                                        <td>per 2 hourly</td>
                                    </tr>
                                    <tr>
                                        <td>RM5.30 (inclusive of 6% GST)</td>
                                        <td>per day/daily coupon</td>
                                    </tr>
                                </tbody>
                            </v-table>
                        </v-card>

                        <v-card class="px-12 py-8">
                            <v-table>
                                <thead>
                                    <tr>
                                        <th colspan="2">At Green Zone (Green Numbering)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>RM0.42 (inclusive of 6% GST)</td>
                                        <td>per hourly</td>
                                    </tr>
                                    <tr>
                                        <td>RM1.70 (inclusive of 6% GST)</td>
                                        <td>per 4 hourly</td>
                                    </tr>
                                    <tr>
                                        <td>RM5.30 (inclusive of 6% GST)</td>
                                        <td>per day/daily coupon</td>
                                    </tr>
                                </tbody>
                            </v-table>
                        </v-card>
                    </div>
                    
                    <div class="mb-12">
                        <p class="font-weight-medium">Coupon parking hours/working hours</p>
                        
                        <v-card class="px-12 py-8 mb-6">
                            <v-table>
                                <thead>
                                    <tr>
                                        <th>Day</th>
                                        <th>Hours</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Monday to Thursday</td>
                                        <td>8am to 5pm</td>
                                    </tr>
                                    <tr>
                                        <td>Friday</td>
                                        <td>8am to 11.45pm<br>2.15pm to 5pm</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">(Except Saturdays, sundays and public holidays)</td>
                                    </tr>
                                </tbody>
                            </v-table>
                        </v-card>
                    </div>
                </v-col>
            </v-row>

            <div class="mb-12">
                <p class="font-weight-medium">Advantages of coupon parking system</p>
                <ul class="ps-6">
                    <li>Easy to use system</li>
                    <li>Unexpired coupons can be used to continue parking at another car park</li>
                    <li>No need to queue to enter car park and make payment at exit point</li>
                    <li>No jam when parking and exiting the car park</li>
                    <li>No need to search for parking machines to make payment</li>
                    <li>No inconvenience due to break down, no electricity or ….. of payment machines</li>
                    <li>System is the cheapest in the world unlike electronic systems which are very expensive to set up.</li>
                </ul>
            </div>

            <div class="mb-12">
                <p class="font-weight-medium">Enforcement</p>
                <ul class="ps-6">
                    <li>Parking wardens inspect vehicles</li>
                    <li>Issue over parking compounds and parking offence notices</li>
                </ul>
            </div>

            <div class="mb-12">
                <v-card class="px-12 py-8">
                    <v-table>
                        <thead>
                            <tr>
                                <th>Compound Fee</th>
                                <th colspan="2">Parking Offences</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in displayedItems" :key="index">
                                <td>RM {{ item.fee }}</td>
                                <td>{{ item['article'] }}</td> 
                                <td>{{ item['parking-offence'] }}</td> 
                            </tr>
                        </tbody>
                    </v-table>
                </v-card>

                <!-- <v-pagination v-model="page" :length="totalPages" class="mt-4"></v-pagination> -->
            </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: 'SeasonParkingPage',
  data() {
    return {
      page: 1,
      itemsPerPage: 20,
      items: [
        { fee: 20, article: 'Article 8(1)', 'parking-offence': 'Without displaying coupon(s).' },
        { fee: 50, article: 'Article 9(1) 9(2)', 'parking-offence': 'Displaying used coupon(s).' },
        { fee: 20, article: 'Article 10(1)', 'parking-offence': 'Coupon(s) not clearly displayed.' },
        { fee: 50, article: 'Article 19(1)', 'parking-offence': 'Causing Obstruction to a parking space.' },
        { fee: 20, article: 'Article 10(3)', 'parking-offence': 'Using coupon(s) ahead of time.' },
        { fee: 30, article: 'Article 17', 'parking-offence': 'Others' },
        { fee: 30, article: 'Article 3(2) 3(4)', 'parking-offence': 'Parking at any place other than in a parking space provided nearby.' },
        { fee: 30, article: 'Article 3(3)', 'parking-offence': 'Parking of vehicle in the parking space not designated for that class of vehicle(s)' },
        { fee: 30, article: 'Article 7(1)', 'parking-offence': 'Parking not entirely within the area marked out as parking space.' },
        { fee: 30, article: 'Article 13(2)', 'parking-offence': 'Failure to produce/surrender coupon(s) when required.' }
      ]
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.items.length / this.itemsPerPage);
    },
    displayedItems() {
      const startIndex = (this.page - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return this.items.slice(startIndex, endIndex);
    }
  }
};
</script>
